import pretty from "pretty";
import cssbeautify from "cssbeautify";

export const beautifyJSON = (json) => {
  return JSON.stringify(JSON.parse(json), null, 2);
};

export const beautifyHTML = (html) => {
  return pretty(html);
};

export const beautifyXML = (xml) => {
  return xml;
};

export const beautifyCSS = (css) => {
  return cssbeautify(css, {
    indent: "  ",
    openbrace: "end-of-line",
    autosemicolon: true,
  });
};

const beautify = (content, type = "xml") => {
  switch (type.toLowerCase()) {
    case "html":
      return beautifyHTML(content);
    case "json":
      return beautifyJSON(content);
    case "xml":
    case "xml+soap":
      return beautifyHTML(content);
    case "css":
      return beautifyCSS(content);
    default:
      return content;
  }
};

export default beautify;
